"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizedHeader = void 0;
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var namespaced = function (key) { return "management/reports/modal/".concat(key); };
var localizedHeaderKey = function (mode, type) {
    var infix = type === SokReducerTypes.TEMPLATE ? 'template/' : String();
    var suffix = mode.toLowerCase();
    return namespaced("".concat(infix).concat(suffix, "Header"));
};
var localizedHeader = function (mode, type) { return (0, translation_1.getLocalization)(localizedHeaderKey(mode, type)); };
exports.localizedHeader = localizedHeader;
